import script from "./ConfettiDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfettiDemo.vue?vue&type=script&setup=true&lang=js"

import "./ConfettiDemo.vue?vue&type=style&index=0&id=17aee491&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17aee491"]])

export default __exports__